'use client';

import BlockContents from '@/components/organisms/BlockContents';
import { API_PUBLIC } from '@/services/ecommerce/apis/apiConstrant';
import AroggaAPI from '@/services/ecommerce/apis/AroggaAPI';
import { useEffect, useState } from 'react';

const DynamicProductContents = ({ data, variant }) => {
	const [blockData, setBlockData] = useState([]) as any;

	const reqData = {
		_page: 1,
		_region: 'single_page_body',
		_per_page: 10,
		_g_product_id: data.p_id,
		more_from_brand_brand_id: data.p_brand_id,
		similar_products_product_variant_id: variant || null,
		frequently_bought_together_product_id: data.p_id,
		_exclude_product_variant_id: variant || null,
		_is_base: 1,
		_allow_sales: 1
	};

	useEffect(() => {
		const getBlockData = async ({ reqData, setBlockData }) => {
			const { data: blockdata } = await AroggaAPI.get(API_PUBLIC.GET_BLOCK, reqData);
			setBlockData(blockdata);
		};
		getBlockData({ reqData, setBlockData });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<BlockContents
			data={blockData?.region_block_data || []}
			params={[
				{ '{_product_id}': data?.p_id },
				{ '{_variant_id}': variant },
				{ '{_brand_id}': data?.p_brand_id },
				{ '{p_type}': data?.p_type }
			]}
			titleParams={[{ '{brand_name}': data?.p_brand?.pb_name }, { '{product_name}': data?.p_name }]}
		/>
	);
};

export const TopBlockContents = ({ data }) => {
	return <BlockContents data={data?.region_block_data || []} />;
};

export default DynamicProductContents;
